import moment from 'moment';

import type { Checklist } from '@cobliteam/api-lib';

import type { ITableColumn } from '@cobliteam/base-components';

export const ReceivedDateColumn = (): ITableColumn<Checklist> => ({
  id: 'createdAt',
  label: 'Data',
  sortable: true,
  orderByKey: (row) => row.createdAt,
  Cell: (row) => moment(row.createdAt).format('DD/MM/YYYY'),
});

export default ReceivedDateColumn;
